export const services = [
  {
    id: 1,
    title: "Man & Van Rubbish Removal Service",
    price: "from £99.99",
    badge: "SAME-DAY",
    badgeType: "sameday",
    image: "https://public.readdy.ai/ai/img_res/79786dc4-32c5-4385-865b-7e88c7062b2a.png",
    href: "/rubbish-clearance",
    wide: false,
  },
  {
    id: 4,
    title: "Sofa Removal",
    price: "from £73.49",
    badge: "SAME-DAY",
    badgeType: "sameday",
    image: "https://cleario.uk/wp-content/uploads/2026/04/edited_e7431d0492d4d3c1b81c1cbf2f06e868_d11e671b-removebg-preview.png",
    href: "/sofa-removal",
    wide: false,
  },
  {
    id: 5,
    title: "Private Bin Collection",
    price: "from £64.99",
    badge: "NEXT-DAY",
    badgeType: "nextday",
    image: "https://cleario.uk/wp-content/uploads/services/bin-collection.png",
    href: "/private-bin-collection",
    wide: false,
  },
  {
    id: 6,
    title: "Furniture Collection",
    price: "from £73.49",
    badge: "NEW",
    badgeType: "new",
    image: "https://cleario.uk/wp-content/uploads/services/furniture-removal.png",
    href: "/furniture-removal",
    wide: false,
  },
  {
    id: 7,
    title: "House Clearance",
    price: "from £71.74",
    badge: "NEW",
    badgeType: "new",
    image: "https://cleario.uk/wp-content/uploads/services/house-clearance.png",
    href: "/house-clearance",
    wide: true,
  },
  {
    id: 8,
    title: "Appliance Removal",
    price: "from £71.74",
    badge: "NEW",
    badgeType: "new",
    image: "https://cleario.uk/wp-content/uploads/services/appliance-removal.png",
    href: "/appliance-removal",
    wide: true,
  },
];

export const stats = [
  {
    value: "Thousands",
    unit: "donated",
    label: "To Make-A-Wish Foundation since 2025.",
    icon: "ri-heart-line",
  },
  {
    value: "95%+",
    unit: "diverted",
    label: "Of every load kept out of landfill.",
    icon: "ri-recycle-line",
  },
  {
    value: "W. Midlands",
    unit: "coverage",
    label: "Solihull, Birmingham, Droitwich Spa, Bromsgrove, Redditch & surrounds.",
    icon: "ri-map-pin-2-line",
  },
  {
    value: "200+",
    unit: "reviews",
    label: "Verified 5-star Trustpilot ratings.",
    icon: "ri-star-line",
  },
];

export const whyFeatures = [
  {
    title: "Tracked & Audited",
    description: "Every job comes with a licensed waste transfer note. We only partner with facilities we've vetted ourselves — because '95% recycled' isn't a guess, it's a measured fact.",
    icon: "ri-leaf-line",
  },
  {
    title: "200+ Verified Reviews",
    description: "The highest-rated nationwide rubbish removal company on Trustpilot. Not a handful of handpicked quotes — tens of thousands of genuine customers, all saying the same thing.",
    icon: "ri-star-line",
  },
  {
    title: "Here When You Need Us",
    description: "Same-day and next-day slots across England, Scotland, Wales and Northern Ireland. If you're staring at a pile of rubbish this morning, we can have it gone by this afternoon.",
    icon: "ri-map-2-line",
  },
  {
    title: "Our Team, Not a Subbie",
    description: "Every member of our team is directly employed, DBS checked and fully vetted. Every van, every driver, every collection — Cleario through and through. No random sub-contractors, no 'third party issues' excuses.",
    icon: "ri-truck-line",
  },
];

export const reviews = [
  {
    id: 1,
    name: "Janet Elizabeth",
    date: "24th March 2026",
    location: "Solihull",
    rating: 5,
    text: "Honestly couldn't have been smoother. The team arrived bang on time, shifted two heavy wardrobes without a scratch on the walls, and were out in under 20 minutes. Brilliant service.",
  },
  {
    id: 2,
    name: "Trevor Harms",
    date: "22nd March 2026",
    location: "Birmingham",
    rating: 5,
    text: "I've used three different clearance companies in the past two years. Cleario are in a different league. Turned up early, got stuck in, left the place spotless. Already booked them again.",
  },
  {
    id: 3,
    name: "Sarah & Ben",
    date: "20th March 2026",
    location: "Bromsgrove",
    rating: 5,
    text: "Live tracking was genuinely useful — I knew exactly when they'd arrive. The guys were friendly, double-checked what we wanted gone, and even swept up after themselves. Can't fault it.",
  },
  {
    id: 4,
    name: "Mrs McDermott",
    date: "18th March 2026",
    location: "Redditch",
    rating: 5,
    text: "I was a bit nervous about strangers in my home but the team were so polite and professional. Treated the place with real care and got the job done quietly and efficiently. 10 out of 10.",
  },
];

export const blogPosts = [
  {
    id: 1,
    date: "23 FEBRUARY 2026",
    title: "How Cleario Diverts Over 95% of Waste Away From Landfill",
    excerpt: "People always ask us how we actually hit that 95% figure. Here's an honest look at the partner facilities we use, how we audit them, and what happens to your rubbish after we drive away.",
    image: "https://readdy.ai/api/search-image?query=bold%20vibrant%20cartoon%20illustration%20of%20a%20busy%20colourful%20waste%20recycling%20sorting%20facility%20with%20bright%20conveyor%20belts%20carrying%20mountains%20of%20green%20glass%20yellow%20cardboard%20and%20red%20cans%20under%20vivid%20industrial%20lighting%2C%20vivid%20saturated%20flat%202D%20vector%20art%2C%20thick%20black%20outlines%2C%20lime%20green%20and%20amber%20accents%2C%20crisp%20storybook%20style%2C%20no%20text%20no%20people&width=800&height=500&seq=blog-recycle-v30&orientation=landscape",
    href: "/news/recycling-facility-birmingham",
    featured: true,
  },
  {
    id: 2,
    date: "01 MARCH 2026",
    title: "Decluttering a Home Office Without Losing Your Mind",
    image: "https://readdy.ai/api/search-image?query=bold%20vibrant%20cartoon%20illustration%20of%20a%20hilariously%20cluttered%20home%20office%20desk%20with%20a%20chunky%20retro%20computer%20tower%20stacks%20of%20toppling%20papers%20tangled%20colourful%20cables%20and%20dusty%20old%20gadgets%20everywhere%2C%20vivid%20saturated%20flat%202D%20vector%20art%2C%20thick%20black%20outlines%2C%20teal%20and%20amber%20accents%2C%20crisp%20storybook%20style%2C%20white%20background%2C%20no%20text%20no%20people&width=400&height=260&seq=blog-office-v30&orientation=landscape",
    href: "/news/home-office-clearances",
    featured: false,
  },
  {
    id: 3,
    date: "01 JULY 2025",
    title: "Skip Hire vs Man & Van Rubbish Removal Service: Which Is Actually Cheaper?",
    image: "https://readdy.ai/api/search-image?query=bold%20vibrant%20cartoon%20illustration%20of%20a%20giant%20bright%20orange%20skip%20bin%20overflowing%20with%20junk%20on%20the%20left%20facing%20a%20gleaming%20white%20removal%20van%20stuffed%20full%20of%20rubbish%20on%20the%20right%20under%20a%20vivid%20blue%20sky%2C%20vivid%20saturated%20flat%202D%20vector%20art%2C%20thick%20black%20outlines%2C%20lime%20green%20and%20navy%20accents%2C%20crisp%20storybook%20style%2C%20no%20text%20no%20people&width=400&height=260&seq=blog-skip-v30&orientation=landscape",
    href: "/news/skip-hire-guide",
    featured: false,
  },
  {
    id: 4,
    date: "05 APRIL 2025",
    title: "Spring Garden Clearance: What We'll Take (And What We Won't)",
    image: "https://readdy.ai/api/search-image?query=bold%20vibrant%20cartoon%20illustration%20of%20a%20cheerful%20British%20garden%20in%20full%20spring%20bloom%20with%20a%20bright%20red%20wheelbarrow%20overflowing%20with%20leafy%20branches%20pruned%20shrubs%20and%20garden%20waste%20under%20a%20brilliant%20vivid%20blue%20sky%2C%20vivid%20saturated%20flat%202D%20vector%20art%2C%20thick%20black%20outlines%2C%20lime%20green%20and%20amber%20accents%2C%20crisp%20storybook%20style%2C%20no%20text%20no%20people&width=400&height=260&seq=blog-garden-v30&orientation=landscape",
    href: "/news/garden-clear-out",
    featured: false,
  },
];

export const faqs = [
  {
    question: "Do you cover my area?",
    answer: "Almost certainly yes. Cleario operates across the entire UK — from the Scottish Highlands to South Cornwall. Enter your postcode at checkout to check live availability and same-day slots near you.",
  },
  {
    question: "How do I get a price?",
    answer: "Use the quote tool at the top of this page, or give us a ring on 03335 775445. Prices are fixed and transparent — no vague estimates or awkward on-the-day surprises.",
  },
  {
    question: "Can you really collect same day?",
    answer: "In most areas, yes. Same-day Man & Van Rubbish Removal Service slots fill up fast, so the earlier you book the better. You'll get a confirmed time window and live driver tracking from the moment we dispatch.",
  },
  {
    question: "Do I need to be at home?",
    answer: "Nope. As long as the waste is accessible, you don't need to be there. Leave a gate code when booking or drop us photos and we'll handle it — we'll send you a confirmation once it's done.",
  },
  {
    question: "What actually happens to my rubbish?",
    answer: "It goes to one of our audited, licensed waste processing partners. On average, over 95% is diverted from landfill. You'll receive a waste transfer note for every collection as legal proof of responsible disposal.",
  },
  {
    question: "I'm not sure how much stuff I have — help?",
    answer: "That's exactly what our free Waste Calculator is for. Build a list of items, and it'll tell you roughly how many cubic yards you've got and which service will save you the most money.",
  },
  {
    question: "What if there's more waste than I thought?",
    answer: "No stress. Our team will let you know on the day and adjust the charge accordingly. We don't leave your stuff behind — we just sort the difference honestly and transparently.",
  },
  {
    question: "Are you licensed to carry waste?",
    answer: "Yes, fully. Cleario holds an upper tier Waste Carrier Licence with the Environment Agency (CBDU 634440). All our drivers are DBS checked, fully vetted, and directly employed — and all facilities are compliant, insured and accountable.",
  },
];